<ng-container [formGroup]="form">
    <extra-settings
        [title]="form.controls['title'].value"
        [hideReference]="hideReference"
        [titleControl]="form.controls['title']"
        [hideTotalToggle]="true"
        [addNumbering]="addNumbering"
        (onOpenReferenceDialog)="openReferenceDialog()"
        (onAddNumberToggleEmit)="onAddNumberToggleChange($event)"
    ></extra-settings>
    <div>
        <aum-toggle [aumFormControl]="form.controls['compareYears']"
            >{{ 'aumico_notes_input_options_compare_years' | i18next }}
        </aum-toggle>
    </div>
    <div>
        <aum-input
            placeholder="{{ 'aumico_notes_input_options_text' | i18next }}"
            [simpleInput]="true"
            [aumFormControl]="form.controls['text']"
        >
        </aum-input>
    </div>
    <div>
        <aum-select
            placeholder="{{ 'aumico_notes_input_options_data_type' | i18next }}"
            [aumFormControl]="form.controls['dataType']"
            [simpleSelect]="true"
            [options]="dataTypeSelections"
        >
            <aum-form-error *ngIf="form.controls['dataType'].touched && form.controls['dataType'].invalid">
                <span *ngIf="form.controls['dataType'].errors['required']">{{
                    'aumico_annual_report_mandatory_field_error' | i18next
                }}</span>
            </aum-form-error>
        </aum-select>
    </div>
    <div
        *ngIf="
            form.controls['dataType'].value?.id === dataType.NUMBER ||
            form.controls['dataType'].value?.id === dataType.CURRENCY
        "
    >
        <aum-select
            placeholder="{{ 'aumico_notes_input_options_number_of_decimal_places' | i18next }}"
            [aumFormControl]="form.controls['numberOfDecimalPlaces']"
            [simpleSelect]="true"
            [options]="numberOfDecimalPlacesSelections"
        >
            <aum-form-error
                *ngIf="form.controls['numberOfDecimalPlaces'].touched && form.controls['numberOfDecimalPlaces'].invalid"
            >
                <span *ngIf="form.controls['numberOfDecimalPlaces'].errors['required']">{{
                    'aumico_annual_report_mandatory_field_error' | i18next
                }}</span>
            </aum-form-error>
        </aum-select>
    </div>
    <div>
        <aum-toggle [aumFormControl]="form.controls['useAsParameter']"
            >{{ 'aumico_notes_input_options_use_as_parameter' | i18next }}
        </aum-toggle>
    </div>
    <div *ngIf="form.controls['useAsParameter'].value">
        <aum-input
            placeholder="{{ 'aumico_notes_input_options_parameter_name' | i18next }}"
            [simpleInput]="true"
            [aumFormControl]="form.controls['parameterName']"
        >
        </aum-input>
    </div>
</ng-container>
